(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smarte-header-usp"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.smarte-header-usp-new .mobile-slider');

  if (swiperEl) {
    const isMobile = window.innerWidth < 870;

    new Swiper(swiperEl, {
      
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
      slidesPerView: 1,
      spaceBetween: 10,
      initialSlide: isMobile ? 2 : 0,
      breakpoints: {
        176: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        870: {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 0,
          autoplay: false,
        }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
